import {useApiQuery} from 'src/hooks/useApiQuery';
import type {ReportListResponse} from 'src/types/byod';
import {BYOD_API_BASE as BASE} from 'src/components/analytics-genesis/byod/api';
import {byodQueryDefaults} from 'src/components/analytics-genesis/byod/api/error-handling';


export function useReportList({
  page = 1,
  pageSize = 15,
}: {page?: number; pageSize?: number} = {}) {
  const offset = (page - 1) * pageSize;
  return useApiQuery<ReportListResponse>(
    {
      pathname: `${BASE}/widgets`,
      query: {limit: String(pageSize), offset: String(offset)},
    },
    {
      queryOptions: {
        ...byodQueryDefaults,
        queryKey: ['byod-report-list', page, pageSize],
        staleTime: 30 * 1000,
        gcTime: 60 * 1000,
        refetchInterval: 60 * 1000,
      },
    },
  );
}
